import React from 'react';
import WeeklyRecipes from '../components/home/WeeklyRecipes';
import QaswilaAlaCarte from '../components/home/QaswilaAlaCarte';
import DietRecipes from '../components/home/DietRecipes';
import SocialLinks from '../components/home/SocialLinks';
import Header from '../components/layout/Header';
import { recipes } from '../data/recipes';
import { Recipe } from '../types/recipe';
import { ThemeCategory } from '../utils/recipeFilters';
import ScrollToTopButton from '../components/common/ScrollToTopButton';

type Props = {
  onRandomRecipe: () => void;
  onIngredientSearch: () => void;
  onRecipeSelect: (recipe: Recipe) => void;
  onViewAllRecipes: () => void;
  onThemeSelect: (theme: ThemeCategory) => void;
};

export default function HomePage({ 
  onRandomRecipe, 
  onIngredientSearch, 
  onRecipeSelect,
  onViewAllRecipes,
  onThemeSelect
}: Props) {

  const handleRecipeSelect = (recipe: Recipe) => {
    // Save scroll position before navigating
    const scrollPosition = window.scrollY;
    sessionStorage.setItem('homeScrollPosition', scrollPosition.toString());
    onRecipeSelect(recipe);
  };

  // Restore scroll position when component mounts
  React.useEffect(() => {
    const savedPosition = sessionStorage.getItem('homeScrollPosition');
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedPosition));
        sessionStorage.removeItem('homeScrollPosition');
      }, 0);
    }
  }, []);

  return (
    <div className="pb-16">
      <Header
        onRandomRecipe={onRandomRecipe}
        onIngredientSearch={onIngredientSearch}
        onRecipeSelect={handleRecipeSelect}
        onViewAllRecipes={onViewAllRecipes}
      />
      <main className="max-w-7xl mx-auto px-4 py-6">
        <WeeklyRecipes 
          recipes={recipes} 
          onRecipeClick={handleRecipeSelect}
        />
        
        <QaswilaAlaCarte 
          onCategorySelect={onThemeSelect}
        />
        
        <DietRecipes 
          onViewAll={() => onThemeSelect('dietetiques')}
        />
        
        <SocialLinks />
      </main>
      <ScrollToTopButton />
    </div>
  );
}